import React from 'react';
import PropTypes from 'prop-types';
import Browser from '@wetransfer/concorde-browser';
import I18n from '@module/i18n';
import Url from '@module/url';

import Icon from '@component/icon';

const WebContent = ({ action, active, item, onClick }) => {
  const classNames = [
    'filelist__item',
    'filelist__item--link',
    'filelist__item--clickable',
  ];

  let previewKey = 'transfer.preview.not_previewable';

  if (!active) {
    previewKey = 'transfer.preview.click_to_open';
  }

  if (active) {
    classNames.push('filelist__item--previewing');
    previewKey = 'transfer.preview.now_open';
  }

  return (
    <li onClick={onClick} className={classNames.join(' ')}>
      <div className="filelist__meta">
        <span className="filelist__name">{item.meta.title}</span>
        <span className="filelist__size">
          <Icon type="Link" /> {Url.extractRootDomain(item.url)}
        </span>
        {Browser.isMobile ? null : (
          <span className="filelist__preview-action">{I18n.t(previewKey)}</span>
        )}
        {action}
      </div>
    </li>
  );
};

WebContent.propTypes = {
  action: PropTypes.object,
  active: PropTypes.bool,
  item: PropTypes.object,
  onClick: PropTypes.func,
};

export default WebContent;
